import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentAwardTemplates = new CRUD('tournament-award-templates', 'superior-judge')

export default Object.assign(
    tournamentAwardTemplates,
    {
        reducers: {
            ...tournamentAwardTemplates.reducers
        },

        queue: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-award-templates/${id}/queue`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        generate: (id, body) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-award-templates/${id}/generate`, body, { responseType: 'blob' })
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
